module.exports = __webpack_public_path__ + "static/media/arrow-white.c920e983.svg";